import { useHomesStore } from '~/store/useHomesStore';
import { useFilters } from './useFilters';

interface SearchActionRequirement {
  key: string;
  met: boolean;
  message: string;
}

interface SearchActionRequirementsResult {
  canExecute: boolean;
  requirements: SearchActionRequirement[];
  unmetMessage: string | null;
}

/**
 * Hook that checks whether all requirements are met for search-related actions
 * like "Bevaka" and "Bevaka sökning".
 *
 * Easily extensible: add new requirements to the array below.
 */
export const useSearchActionRequirements = (): SearchActionRequirementsResult => {
  const filters = useHomesStore((s) => s.filters);
  const { hasFilters } = useFilters();

  const requirements: SearchActionRequirement[] = [
    {
      key: 'has_filters',
      met: !!hasFilters(),
      message: 'Lägg till filter för att bevaka sökningen',
    },
    {
      key: 'has_category',
      met: Boolean(filters?.categories && filters.categories.length > 0),
      message: 'Välj en bostadstyp för att bevaka sökningen',
    },
    // Add more requirements here as needed, e.g.:
    // {
    //   key: 'has_location',
    //   met: Boolean(filters?.areaIds?.length || filters?.municipalityIds?.length),
    //   message: 'Välj ett område eller kommun',
    // },
  ];

  const unmet = requirements.filter((r) => !r.met);

  return {
    canExecute: unmet.length === 0,
    requirements,
    unmetMessage: unmet.length > 0 ? unmet[0].message : null,
  };
};
